exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tooltip__Uo3h {\n  width: 275px; }\n", "", {"version":3,"sources":["/app/src/ui/components/src/ui/components/page-height-warning.scss"],"names":[],"mappings":"AAAA;EACE,aAAa,EACd","file":"page-height-warning.scss","sourcesContent":[".tooltip {\n  width: 275px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tooltip": "tooltip__Uo3h"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/components/page-height-warning.scss
// module id = 787
// module chunks = 0